import { render, staticRenderFns } from "./CampaignTab.vue?vue&type=template&id=1ab2d035&"
import script from "./CampaignTab.vue?vue&type=script&lang=js&"
export * from "./CampaignTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports